<select class="q-main-select widthSelect m-3" (change)="UpdateGrid()" [(ngModel)]="codeVisuGrid" *ngIf="listTypesBilan && listTypesBilan.length > 0">
  <option value="">-----</option>
  <option *ngFor="let type of listTypesBilan" value="{{type.id}}">{{type.value}}</option>
</select>

<button class="btn q-btn q-main my-4 px-2" (click)="OpenModalCreationBilan()" title="Création d'un nouveau bilan" [disabled]="isTrainingProgressReportLocked" *ngIf="codeVisuGrid != 'BO_POSI_QUEST'"> Nouveau bilan <i class="fas fa-plus px-1"></i></button>

<button class="btn q-btn q-danger m-2" type="button" (click)="OpenModalDeleteValidation()"
        title="Supprimer les bilans sélectionnés" [disabled]="!selectedNodes?.length" *ngIf="codeVisuGrid != 'BO_POSI_QUEST'">
  Supprimer
</button>



<!-- CUSTOM GRID -->
<div *ngIf="fileNameForGrid" class="h-100 w-100">
  <div class="grid pt-0">
    <q-customgrid [customgridName]="fileNameForGrid"
                  [idDonnee]="service.Stage.Ident"
                  [(refreshData)]="refreshData"
                  (selectChanged)="selectLine($event)"
                  (cellValueChanged)="saveValueChanged($event)">
    </q-customgrid>
  </div>
</div>

<!--#region modal BO GRID-->
<ng-template #ModalBo let-modalBo>
  <div #header class="modal-header">
    <h5 class="modal-title" id="modalGrid">{{boModel.Title}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalBo.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body overflow-auto">
    <q-bodisplay [globalsave]="false" [item]="boModel" (sendEvent)="onAfterSaveBo($event, modalBo)"></q-bodisplay>
  </div>
</ng-template>
<!--#endregion modal BO GRID -->
<!--#region modal Nouveau Bilan-->
<ng-template #ModalCreateBoBilan let-modalCreateBoBilan>
  <div #header class="modal-header">
    <h3 class="modal-title q-c-main" id="modalBilan">Création des certifications pour les apprenants</h3>
    <button type="button" class="close" aria-label="Close" (click)="getEvent(modalCreateBoBilan)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body overflow-auto d-flex justify-content-center flex-wrap">
    <div class="row my-3 ml-3 w-100">
      <button [disabled]="!(boModelBilan.Apprenants && boModelBilan.Apprenants.length > 0)" class="q-btn q-main q-btn-save-custom" (click)="OnValidateBo()"><i class="fas fa-save mr-2"></i>Générer les bilans</button>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-12 my-3" style="height: 70vh;">
        <q-effectifs [Option]="OptionStagiaire" (EffectifToEmit)="UpdateListEffectif($event)"></q-effectifs>
      </div>
      <div class="col-lg-8 col-md-8 col-12 my-3">
        <q-bodisplay #bodisplay
                     [item]="boModelBilan.BoPosition"
                     [validate]="validateBo"
                     (isDataBoValid)="OnAfterValidateBo($event)"
                     (sendEventAfterValidate)="CreateBoPosition($event, modalCreateBoBilan)">
        </q-bodisplay>
      </div>
    </div>
  </div>
</ng-template>
<!--#endregion modal Bilan -->
<!--#region modal Objectifs-->
<ng-template #ModalCreateObjectifs let-modalCreateObjectifs>
  <div #header class="modal-header">
    <h3 class="modal-title q-c-main" id="modalObjectifs">Création des objectifs pédagogiques</h3>
    <button type="button" class="close" aria-label="Close" (click)="getEvent(modalCreateObjectifs)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body overflow-auto">
    <queoval-stage-create-objectifs (bilanGenere)="EventAfterBilanGenerate(modalCreateObjectifs)"></queoval-stage-create-objectifs>
  </div>
</ng-template>
<!--#endregion Objectifs -->
<!--  MODAL de validation de la suppression des bilans -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement ces bilans ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteSelection();modal.dismiss()"
              title="Supprimer les bilans" [disabled]="!selectedNodes?.length">
        Supprimer
      </button>
    </div>
  </div>
</ng-template>
